import {
  ICategorySoldProducts,
  TComplexSectionData,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { checkCategory } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/soldProducts/helpers/checkCategory'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'
import { Title } from '../../styledComponents/title/Title'
import { CheckBoxThree } from '../checkBoxThree/CheckBoxThree'
import { printSoldItems } from '../configs'
import { checkProducts } from '../helpers/checkProducts'

interface IProps {
  data: ICategorySoldProducts[]
  updateFormData: (data: TComplexSectionData) => void
}

export const SoldPrintProducts = ({ data, updateFormData }: IProps) => {
  const onCheckProducts = checkProducts(updateFormData, data)
  const onCheckCategory = checkCategory(updateFormData, data, printSoldItems)
  return (
    <div>
      <Title
        variant={'withLightBackground'}
        text={getFormedEltTranslation('section-sold-ps-products')}
      />
      <CheckBoxThree
        staticData={printSoldItems}
        selectedData={data}
        onCheckProducts={onCheckProducts}
        onCheckCategory={onCheckCategory}
      />
    </div>
  )
}
